import styled from "styled-components";

export const StyledSupportCopyCompact = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 191px;
`;

export const StyledSupportCopyText = styled.div`
  display: inline-block;
  max-width: 137px;
  color: ${({ theme }) => theme.rgba.black_100_50};
  font-weight: 500;
  text-align: center;
  font-family: ${(props) => props.theme.figma.base.fontfamily_mlstifo_standard};
  font-size: ${({ theme }) =>
    theme.mixins.pxToRem(theme.figma.base.scale_1_375)};
`;

export const StyledSponsorWrapper = styled.div`
  max-width: 64px;
  max-height: 28px;

  picture {
    img.mls-o-sponsor__image {
      width: 100%;
      height: 28px;
      object-fit: contain;
    }
  }
`;

export const StyledDivider = styled.div`
  height: 30px;
  margin: 0 12px;
  border-right: 1px solid ${({ theme }) => theme.rgba.black_33_25};
`;
